import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate, useLocation } from 'react-router-dom';
import { io } from 'socket.io-client';
import Auth from './Auth';
import Dashboard from './Dashboard';
import './App.css';

import Home from './Home';
import SignIn from './SignIn';
import SignUp from './SignUp';
import ConfirmEmail from './ConfirmEmail';
import ResetPassword from './ResetPassword';
import UpdatePassword from './UpdatePassword';
import AuthCallback from './AuthCallback';
import StarfieldBackground from './StarfieldBackground';
import Payment from './Payment';
import Settings from './Settings';
import Receipt from './components/Receipt';
import Orders from './Orders';

function TopAuthButtons() {
  const navigate = useNavigate();
  const location = useLocation();
  // Hide on /signin and /signup
  if (location.pathname === '/signin' || location.pathname === '/signup') return null;
  return (
    <div className="top-auth-buttons">
      <button className="top-auth-btn" onClick={() => navigate('/signin')}>Sign In</button>
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState('online');
  const [socket, setSocket] = useState(null);

  // Function to fetch status
  const fetchStatus = () => {
    fetch('/api/status')
      .then(res => res.json())
      .then(data => {
        console.log('Status check:', data);
        setStatus(data.status);
      })
      .catch(err => console.error('Error fetching status:', err));
  };

  useEffect(() => {
    // Get initial status
    fetchStatus();

    // Set up polling interval
    const statusInterval = setInterval(fetchStatus, 5000); // Check every 5 seconds

    // Initialize WebSocket connection
    const newSocket = io();
    setSocket(newSocket);

    // Listen for status updates
    newSocket.on('status-update', (data) => {
      console.log('Status update received:', data);
      setStatus(data.status);
    });

    // Handle connection events
    newSocket.on('connect', () => {
      console.log('Connected to server');
    });

    newSocket.on('disconnect', () => {
      console.log('Disconnected from server');
      setStatus('offline');
    });

    // Cleanup on component unmount
    return () => {
      clearInterval(statusInterval); // Clean up interval
      newSocket.close();
    };
  }, []);

  return (
    <Router>
      <StarfieldBackground />
      <div className="app-container">
        {!user && <TopAuthButtons />}
        <div className="branding">
          <h1>CLICKYBOIS</h1>
          <div style={{ fontSize: '1.1em', fontWeight: 600, marginTop: 6, color: status === 'online' ? '#4caf50' : '#ff4757', letterSpacing: 1 }}>
            {status === 'online' ? 'Online' : 'Offline'}
          </div>
        </div>
        <Routes>
          <Route path="/" element={<Home onAuth={setUser} />} />
          <Route path="/signin" element={<SignIn onAuth={setUser} />} />
          <Route path="/signup" element={<SignUp onAuth={setUser} />} />
          <Route path="/confirm-email" element={<ConfirmEmail onAuth={setUser} />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/update-password" element={<UpdatePassword />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/dashboard" element={user ? <Dashboard user={user} /> : <Navigate to="/signin" />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/payment/:orderId" element={<Receipt />} />
          <Route path="/orders" element={user ? <Orders user={user} /> : <Navigate to="/signin" />} />
          <Route path="/settings" element={user ? <Settings user={user} /> : <Navigate to="/signin" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
